import { isDefined } from "@clipboard-health/util-ts";
import { useEffect, useState } from "react";

/**
 * Fetches a remote image and converts it to a base64 data URL.
 * This is needed for DOM-to-image capture (e.g. `domToPng`) because
 * cross-origin images taint the canvas in mobile WebViews, causing
 * the image to be silently excluded from the screenshot.
 */
export function useImageAsDataUrl(imageUrl: string | undefined): string | undefined {
  const [dataUrl, setDataUrl] = useState<string | undefined>();

  useEffect(() => {
    if (!isDefined(imageUrl)) {
      setDataUrl(undefined);
      return;
    }

    let cancelled = false;

    async function fetchAsDataUrl() {
      try {
        const response = await fetch(imageUrl!);
        const blob = await response.blob();

        const reader = new FileReader();
        reader.onloadend = () => {
          if (!cancelled && typeof reader.result === "string") {
            setDataUrl(reader.result);
          }
        };
        reader.readAsDataURL(blob);
      } catch {
        // Fall back to undefined — the card will show the bunny icon instead
      }
    }

    void fetchAsDataUrl();

    return () => {
      cancelled = true;
    };
  }, [imageUrl]);

  return dataUrl;
}
